import React from 'react';
import { useNavigate } from "react-router-dom";

import { getPhotoData } from "~/providers/martine-photos";

import "./style.less";

export default function MartinekPage() {
	const navigate = useNavigate();
	const photoData = getPhotoData();

	function goToGallery(galleryItem) {
		navigate(`/galerie/martinek/${galleryItem.type}/${galleryItem.seo}`);
	}

	return <div className="martinekPage">
		<h2 className="martinekPage__title">Martínek</h2>
		<ul>
			<li>Narodil se 11. 12. 2021, 10:30</li>
			<li>Měřil 49 cm</li>
			<li>Vážil 3540g</li>
		</ul>
		<h2 className="martinekPage__title">Galerie</h2>
		<div className="martinekPage__galleries">
			{ photoData.map(item => <div className="martinekPage__gallery" key={item.seo} onClick={() => goToGallery(item)}>
				<div className="martinekPage__galleryHolder">
					<img src={item.cover} alt={item.alt} className="martinekPage__galleryCover" />
				</div>
				<h3 className="martinekPage__galleryTitle">{item.title}</h3>
			</div>)}
		</div>
	</div>;
}
